import { useEffect } from "react";
import { LogIn } from "lucide-react";
import { useAuth } from "./useAuth";
import { setAdminMode } from "../lib/overlay";

// Topbar sign-in affordance for the Admin identity plane. Anonymous → "Sign in". When signed in
// there's no separate chip — the admin's Sign out now lives in the Admin menu — but this still
// syncs admin mode so admins see every lifecycle stage in listings (drafts reachable to edit).
export function AuthMenu() {
  const auth = useAuth();

  useEffect(() => {
    setAdminMode(auth.isAdmin);
  }, [auth.isAdmin]);

  if (!auth.signedIn) {
    return (
      <button type="button" className="nav-link" onClick={auth.login} disabled={!auth.ready}>
        <LogIn size={15} /> Sign in
      </button>
    );
  }
  return null;
}
